import { fitBounds as gmapsFitBounds } from 'google-map-react/utils';

const DEFAULT_BOUNDS = { width: 0, height: 0 };
const DEFAULT_POINT = { lat: 0, lng: 0 };

function fitBounds(
  coordinates = [],
  bounds = DEFAULT_BOUNDS,
  defaultCenter = DEFAULT_POINT,
  defaultZoom = 0
) {
  const northern = {};
  const eastern = {};
  const southern = {};
  const western = {};
  const pointsCache = {};
  const defaultResult = {
    center: defaultCenter,
    zoom: defaultZoom,
    newBounds: null
  };

  coordinates.forEach(point => {
    if (!point) {
      return;
    }

    const key = `${point.lat}:${point.lng}`;
    if (pointsCache[key]) {
      return;
    }

    if (!northern.lat || point.lat > northern.lat) {
      northern.lat = point.lat;
      northern.lng = point.lng;
    }
    if (!eastern.lng || point.lng > eastern.lng) {
      eastern.lat = point.lat;
      eastern.lng = point.lng;
    }
    if (!southern.lat || point.lat < southern.lat) {
      southern.lat = point.lat;
      southern.lng = point.lng;
    }
    if (!western.lng || point.lng < western.lng) {
      western.lat = point.lat;
      western.lng = point.lng;
    }

    pointsCache[key] = true;
  });

  const pointsLength = Object.keys(pointsCache).length;
  if (pointsLength === 0) {
    return defaultResult;
  }

  if (pointsLength === 1) {
    defaultResult.center = coordinates[0];
    defaultResult.zoom = 15;
    return defaultResult;
  }

  let corners = {
    nw: {
      lat: northern.lat,
      lng: western.lng
    },
    se: {
      lat: southern.lat,
      lng: eastern.lng
    }
  };

  return gmapsFitBounds(corners, bounds);
}

export default fitBounds;
